module.exports = __webpack_public_path__ + "img/close.468e0e94.svg";